
(() => {
  const passiveEvents = ['touchstart', 'touchmove', 'wheel', 'mousewheel'];
  const orig = EventTarget.prototype.addEventListener;

  EventTarget.prototype.addEventListener = function (
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ) {
    let opts: AddEventListenerOptions;
    if (passiveEvents.includes(type)) {
      // Normaliza options como objeto y fuerza passive:true
      if (typeof options === 'boolean' || options === undefined) {
        opts = { passive: true, capture: !!options };
      } else {
        opts = { ...options, passive: true };
      }
    } else {
      // Para otros eventos dejamos la opción que pasen
      if (typeof options === 'boolean' || options === undefined) {
        opts = { capture: !!options };
      } else {
        opts = options;
      }
    }
    return orig.call(this, type, listener, opts);
  };
})();

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { LogLevel, setLogLevel } from '@angular/fire';
setLogLevel(LogLevel.SILENT);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
